import { useState } from 'react';
import './Pay.css';
import logo from '../../img/logo_uam.png'
import wave from '../../img/wave.jpg'
import om from '../../img/OM.jpg'
import axios from 'axios';
import freemoney from '../../img/free-money.jpg'
import expresso from '../../img/expresso.jpg'
import { Image, Form,Container,Button,Spinner } from 'react-bootstrap';
import IdTransaction from '../../components/idTransaction/IdTransaction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import AlerteMessage from '../../components/AlerteMessage';
import Env from '../../hooks/Env';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useNavigate } from 'react-router-dom';
import ErrorPage from '../../components/Error';

function PayAdmission ({prix=10000}) {
    useDocumentTitle('Paiement Admission');
    const URL = Env().API_URL ;
    const navigate = useNavigate();
    const [data, setData] = useState('');
    const [show, setShow] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [checked, SetChecked] = useState(false);
    const [open, setOpen] = useState (false);
    const [message, setMessage] = useState (false) ;
    const [error, setError] = useState(null);
    
    // État pour la vérification de paiement existant
    const [showAlreadyPaid, setShowAlreadyPaid] = useState(false);
    const [emailVerification, setEmailVerification] = useState('');
    const [verificationLoading, setVerificationLoading] = useState(false);
    const [verificationError, setVerificationError] = useState('');
    
    const [valid, SetIsValid] = useState({
        isValidEmail: false,
        isValidPhoneNumber: false,
      });
    const handleChange = (e) => {
        const name= e.target.name;
        const value = e.target.value;
        // setData({ ...data, [name]: value }); //clé valeur du champs
        setData((prevData) => ({ ...prevData, [name]: value, pays: prix }));
        if (name === 'telephone' ) {
            const phoneRegex = /^\d{1,25}$/
;  //validation numéro de téléphone
            SetIsValid((valid) => ({
                ...valid,
                isValidPhoneNumber: phoneRegex.test(value),
            }));
        }
        if (name === 'email') {
            //validation email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            SetIsValid((valid) => ({
                ...valid,
                isValidEmail: emailRegex.test(value),
            }));
        }
        if (name === 'operateur') {
            SetChecked(e.target.checked)
        }
    }
    const handleClose3 = () => {
        setOpen(false)
    }
    
    // Fonction pour vérifier si le paiement a déjà été effectué
    const handleVerifyPayment = (e) => {
        e.preventDefault();
        setVerificationLoading(true);
        setVerificationError('');
        
        axios({
            url: `${URL}/paiement/confirmed/admission/${emailVerification}/${Env().ANNEE_UNIVERSITE}`,
            method: 'GET',
        })
        .then(result => {
            if (result?.data?.detail || result.data.amount !== '10125') {
                setVerificationError('Aucun paiement trouvé pour cet email. Veuillez effectuer le paiement.');
            } else {
                // Paiement trouvé, redirection vers le formulaire
                navigate(`/admission?email=${emailVerification}`);
            }
        })
        .catch((error) => {
            console.log('Error:', error);
            setVerificationError('Aucun paiement trouvé pour cet email. Veuillez effectuer le paiement.');
        })
        .finally(() => {
            setVerificationLoading(false);
        });
    }
    
    let NotComplete = true;
    if (!valid.isValidEmail || !valid.isValidPhoneNumber || !checked) {
        NotComplete = false;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
        data['campagne'] = 'admission' ;
        data['annee_universitaire'] = Env().ANNEE_UNIVERSITE ;
        console.log("Send to API "+data)
        axios({
            url:`${URL}/paiement/`,
            method: 'POST',
            data:data
        })
        .then(result => {
            console.log("Initialisation Success");
            console.log('Data from API :', result.data);
            if (result.data.message==='OK') {
                console.log(result.data)
                setSubmitted(false);
                setShow(true);
                if (result.data.paymentURL) {
                    window.location.href = result.data.paymentURL;
                //    window.open(result.data.paymentURL, "_blank");
                }
            }
            //window.location.href = result.data.paymentURL;
        })
        .catch((error) => {
            setError(true);
            if (error.response.status === '500') {
                setOpen(true)
                setMessage('Impossible d\'initier un paiement ')
            } else {
                if (error.response.data.detail) {
                    setOpen(true)
                    setMessage('Impossible d\'initier un paiement ')
                }
            }
            // console.error('Error:', error);
            setSubmitted(false);
        });
    }
    return (
        <>
        <AlerteMessage open={open} handleClose={handleClose3} message={message} />
        {error && <ErrorPage error={error} errorCode={500} errorMessage="Une erreur s'est produite lors de l'initialisation du paiement. Veuillez réessayer plus tard." />}
        <IdTransaction show={show} email={data.email} handleClose={() => 
            {setShow(false)}
            } />
        <Container className='pay' id='main'>
            <div className='d-flex flex-row' id='payHead'>
                <div>
                    <Image src={logo} width={239} height={220} />
                </div>
                <div className='' id='texthead'>
                    <p>Université Amadou Mahtar Mbow </p>
                    <p>Année Académique 2025-2026</p>
                </div>
            </div>
            
            {/* Section pour ceux qui ont déjà payé */}
            <div className='mb-4 text-center'>
                <p 
                    className='text-primary' 
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => setShowAlreadyPaid(!showAlreadyPaid)}
                >
                    Vous avez déjà payé ? Cliquez ici pour accéder au formulaire
                </p>
                
                {showAlreadyPaid && (
                    <Form onSubmit={handleVerifyPayment} className='mt-3'>
                        <Form.Group className='mb-3'>
                            <Form.Control 
                                placeholder='Entrez votre email de paiement'
                                size='md'
                                type='email'
                                name='emailVerification'
                                className='p-2 custom-email-input'
                                value={emailVerification}
                                onChange={(e) => setEmailVerification(e.target.value)}
                                required
                            />
                        </Form.Group>
                        {verificationError && (
                            <p className='text-danger'>{verificationError}</p>
                        )}
                        <Button
                            type='submit'
                            variant='success'
                            disabled={!emailVerification || verificationLoading}
                            className='w-50'
                        >
                            {verificationLoading ? (
                                <Spinner animation="border" size="sm" />
                            ) : (
                                'Accéder au formulaire'
                            )}
                        </Button>
                    </Form>
                )}
                <hr />
            </div>
            
            <div>
                <Form onSubmit={handleSubmit} className=''>
                    <div className='p-4 row'>
                        <Form.Group className='col-md-6 col-sm-12'>
                            <Form.Control 
                                placeholder='Numero de Telephone'
                                size='md'
                                type='number'
                                name='telephone'
                                className='p-2 custom-email-input'
                                onChange={handleChange}
                                autoFocus
                                required
                            />
                        </Form.Group>
                        <Form.Group className='col-md-6 col-sm-12'>
                            <Form.Control 
                                placeholder='Email'
                                size='md'
                                type='email'
                                name='email'
                                className='p-2 custom-email-input'
                                onChange={handleChange}
                                required
                            />
                        </Form.Group>
                        <div>
                        <p className='text-danger ml-2' id='frais'>Le paiement des droits d'inscription, non remboursables, sont de dix mille (10 000) F. CFA + frais de 125 F. CFA</p>
                    </div>
                    </div>
                    <Form.Group>
                        <Form.Check
                            inline
                            onChange={handleChange}
                            type="radio"
                            id="wave"
                            name="operateur"
                            value="wave"
                            label = {
                                <Image src={wave} height={80} width={80} alt="wave" />
                            }
                        />
                        <Form.Check
                            inline
                            onChange={handleChange}
                            type="radio"
                            id="wave"
                            name="operateur"
                            value="orange-money"
                            label = {
                                <Image src={om} height={80} width={80} alt="wave" />
                            }
                        />
                        <Form.Check
                            inline
                            onChange={handleChange}
                            type="radio"
                            id="wave"
                            name="operateur"
                            value="free-money"
                            label = {
                                <Image src={freemoney} height={80} width={80} alt="wave" />
                            }
                        />
                        <Form.Check
                            inline
                            onChange={handleChange}
                            type="radio"
                            id="wave"
                            name="operateur"
                            value="e-money"
                            label = {
                                <Image src={expresso} height={80} width={80} alt="wave" />
                            }
                        />
                        {/* <Form.Check
                            inline
                            onChange={handleChange}
                            type="radio"
                            id="wave"
                            name="operateur"
                            value="mobilebank"
                            label = {
                                <Image src={bank} height={80} width={80} alt="cartebancaire" />
                            }
                        /> */}
                    </Form.Group>
                   
		
		{/* <input onClick={callTouchPay} className='intouch' type='button'  value='Payer avec carte'/> */}

                    <Button
                        onClick={handleSubmit}
                        variant='primary' 
                        disabled={!valid.isValidEmail || !valid.isValidPhoneNumber || !checked} type='button'
                        className ='w-75 btn-submit'
                        >
                            {NotComplete ? (<span>Payer avec {data.operateur}</span>)  : <FontAwesomeIcon icon={faBan} className='color-logo' />} 
                            {submitted ? 
                                <Spinner animation="grow"
                                    size="sm" role="status"
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner> 
                            : null} 
                    </Button>
                </Form>
            </div>
        </Container>
        </>
    )
}
export default PayAdmission
